import {
  adjustPosition,
  CHART_HANDLERS_MAP,
  CHART_INITIALIZATIONS_MAP,
  CHART_TYPES,
} from './mock'

export const getCurrentChartProgress = async () => {
  const wpnonce = window?.dataWP?.config?.wpnonce

  const wpNonceParam = wpnonce ? `?_wpnonce=${wpnonce}` : ''

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/clearthecharts/current-chart-progress${wpNonceParam}`,
    {
      method: 'GET',
    },
  )
    .then((res) => {
      if (!res.ok) {
        throw Error('Response error')
      }
      return res.json()
    })
    .then((data) => data)
}

export const saveCurrentChartProgress = async (chartId, data) => {
  const wpnonce = window?.dataWP?.config?.wpnonce

  const wpNonceParam = wpnonce ? `?_wpnonce=${wpnonce}` : ''

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/clearthecharts/current-chart-progress/${chartId}${wpNonceParam}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    },
  )
    .then((res) => {
      if (!res.ok) {
        throw Error('Response error')
      }
      return res.json()
    })
    .then((data) => data)
}

export const getUserStats = async () => {
  const wpnonce = window?.dataWP?.config?.wpnonce

  const wpNonceParam = wpnonce ? `?_wpnonce=${wpnonce}` : ''

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/clearthecharts/user-stats${wpNonceParam}`,
    {
      method: 'GET',
    },
  )
    .then((res) => {
      if (!res.ok) {
        throw Error('Response error')
      }
      return res.json()
    })
    .then((data) => data)
}

export const saveUserStats = async (chartId, data) => {
  const wpnonce = window?.dataWP?.config?.wpnonce

  const wpNonceParam = wpnonce ? `?_wpnonce=${wpnonce}` : ''

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/clearthecharts/user-stats/${chartId}${wpNonceParam}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    },
  )
    .then((res) => {
      if (!res.ok) {
        throw Error('Response error')
      }
      return res.json()
    })
    .then((data) => data)
}

export async function getChart({
  chartMode,
  type = 'MTTs Full Ring',
  filter = null,
}) {
  const formData = new FormData()
  if (!filter) {
    formData.append('chart_type', type)
    formData.append('action', CHART_INITIALIZATIONS_MAP[chartMode])
  } else {
    formData.append('db', 'crawler')
    formData.append('rules', 'true')

    formData.append('action', CHART_HANDLERS_MAP[chartMode])
    formData.append('filter[type]', CHART_TYPES[filter.chartType])
    formData.append('filter[blinds]', filter.stack)
    const position =
      filter.chartType === 'CASH GAME'
        ? filter.position
        : adjustPosition(filter.position)
    formData.append('filter[position]', position)

    formData.append('filter[action]', filter.action)
    formData.append('filter[opposition]', filter.oppos)
  }

  const wpnonce = window?.dataWP?.config?.wpnonce

  const wpNonceParam = wpnonce ? `?_wpnonce=${wpnonce}` : ''

  return fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/get_charts${wpNonceParam}`,
    {
      method: 'POST',
      body: formData,
    },
  )
    .then((res) => {
      if (!res.ok) {
        throw Error('Response error')
      }
      return res.json()
    })
    .then((data) => data)
}

export const getUserDataByKey = async ({ key }) => {
  const wpnonce = window?.dataWP?.config?.wpnonce

  const wpNonceParam = wpnonce ? `&_wpnonce=${wpnonce}` : ''

  const response = await fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/get_user_data?key=${key}${wpNonceParam}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
  const data = await response.json()
  return data
}

export const getPreflopData = async () => {
  const wpnonce = window?.dataWP?.config?.wpnonce

  const wpNonceParam = wpnonce ? `&_wpnonce=${wpnonce}` : ''

  const response = await fetch(
    `${window.dataWP.config.endpoints.home_url}/wp-json/pokercoaching/v1/get_preflop_chart?crawler=true&rules=true&add_hu=true${wpNonceParam}`,
    {
      method: 'GET',
    },
  )

  const data = await response.json()

  return data
}
